import _regeneratorRuntime from "/root/app/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import * as FullStory from '@fullstory/browser';
var FULLSTORY_CHECK_INTERVAL_MSEC = 100;
var FULLSTORY_MAX_WAIT_FOR_INIT = 4000;
var FULLSTORY_MAX_WAIT_FOR_CALL = FULLSTORY_MAX_WAIT_FOR_INIT * 2;
export var FullStoryNotExistError = /*#__PURE__*/function (_Error) {
  _inherits(FullStoryNotExistError, _Error);

  var _super = _createSuper(FullStoryNotExistError);

  function FullStoryNotExistError() {
    _classCallCheck(this, FullStoryNotExistError);

    return _super.call(this, "FullStory was not found on the page.");
  }

  return FullStoryNotExistError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Returns the FullStory namespace, which should only exist if FullStory was initialized
 * @return {String} the FullStory namespace
 */

export function getFullStoryNameSpace() {
  return window['_fs_namespace'];
}
/**
 * Returns a promise that will be fulfilled when FullStory is initialized, or rejected after a max wait
 * @param {Number} maxWait - the maximum time to wait for FullStory to be initialized before rejecting
 * @return {Promise} - the FullStory initialization promise
 */

export function waitForFullStory() {
  return _waitForFullStory.apply(this, arguments);
}
/**
 * Initializes FullStory, if not already initialized by GTM.  It waits a little bit for GTM to init before trying
 * @param {Number} maxWait - the maximum time to wait for GTM to initialize FullStory before doing it here
 */

function _waitForFullStory() {
  _waitForFullStory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var maxWait,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            maxWait = _args.length > 0 && _args[0] !== undefined ? _args[0] : FULLSTORY_MAX_WAIT_FOR_CALL;

            if (!getFullStoryNameSpace()) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", Promise.resolve());

          case 3:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var intervalsRemain = maxWait / FULLSTORY_CHECK_INTERVAL_MSEC;
              var intervalCheck = setInterval(function () {
                if (getFullStoryNameSpace()) {
                  clearInterval(intervalCheck);
                  resolve();
                } else if (! --intervalsRemain) {
                  clearInterval(intervalCheck);
                  reject(new FullStoryNotExistError());
                }
              }, FULLSTORY_CHECK_INTERVAL_MSEC);
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _waitForFullStory.apply(this, arguments);
}

export function initFullStory() {
  return _initFullStory.apply(this, arguments);
}
/**
 * Calls a FullStory API function.  It automatically handles waiting for FullStory to be initialized before making
 * the call.
 * @param {String} funcName - the name of the API function to call
 * @param {any} args - any remaining arguments are passed to the FullStory API function
 */

function _initFullStory() {
  _initFullStory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var maxWait,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            maxWait = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : FULLSTORY_MAX_WAIT_FOR_INIT;
            _context2.prev = 1;
            _context2.next = 4;
            return waitForFullStory(maxWait);

          case 4:
            console.log('[FullStory] was initialized by GTM');
            _context2.next = 15;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](1);

            if (!(_context2.t0 instanceof FullStoryNotExistError)) {
              _context2.next = 14;
              break;
            }

            console.log('[FullStory] initializing directly, not initialized by GTM');
            FullStory.init({
              orgId: 'VG8R8'
            });
            _context2.next = 15;
            break;

          case 14:
            throw _context2.t0;

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 7]]);
  }));
  return _initFullStory.apply(this, arguments);
}

export function callFullStory(_x) {
  return _callFullStory.apply(this, arguments);
}
/**
 * Sets the user context for FullStory (after user data fetch)
 * @param {Object} userData - User data
 */

function _callFullStory() {
  _callFullStory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(funcName) {
    var fsNS,
        _window$fsNS,
        _len,
        args,
        _key,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return waitForFullStory();

          case 3:
            fsNS = getFullStoryNameSpace();

            if (fsNS) {
              console.log('[FullStory] calling FS API:', funcName);

              for (_len = _args3.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = _args3[_key];
              }

              (_window$fsNS = window[fsNS])[funcName].apply(_window$fsNS, args);
            }

            _context3.next = 14;
            break;

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);

            if (!(_context3.t0 instanceof FullStoryNotExistError)) {
              _context3.next = 13;
              break;
            }

            console.error('[FullStory] unable to find FullStory namespace on page after max wait');
            _context3.next = 14;
            break;

          case 13:
            throw _context3.t0;

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));
  return _callFullStory.apply(this, arguments);
}

export function setFullStoryIdentity(_x2) {
  return _setFullStoryIdentity.apply(this, arguments);
}
/**
 * Resets the user context for FullStory (at logout)
 */

function _setFullStoryIdentity() {
  _setFullStoryIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(userData) {
    var email, id, firstName, lastName;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            email = userData.email, id = userData.id, firstName = userData.firstName, lastName = userData.lastName;
            _context4.next = 3;
            return callFullStory('identify', id, {
              email: email,
              firstName: firstName,
              lastName: lastName
            });

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _setFullStoryIdentity.apply(this, arguments);
}

export function resetFullStoryIdentity() {
  return _resetFullStoryIdentity.apply(this, arguments);
}

function _resetFullStoryIdentity() {
  _resetFullStoryIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return callFullStory('anonymize');

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _resetFullStoryIdentity.apply(this, arguments);
}

export default initFullStory;